import React from 'react'
// import Headermid from './Headermid'
import Headerbottom from './Headerbottom'
import './Header.css'

function Header() {
  return (
    <div className='Header'>
        {/* <Headermid /> */}
        <Headerbottom />
    </div>
  )
}

export default Header